import { render } from "./DocumentosEmpresa.vue?vue&type=template&id=036f58ad&scoped=true"
import script from "./DocumentosEmpresa.vue?vue&type=script&lang=js"
export * from "./DocumentosEmpresa.vue?vue&type=script&lang=js"

import "./DocumentosEmpresa.vue?vue&type=style&index=0&id=036f58ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f58ad"]])

export default __exports__